import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./UserConsent.css";

class UserConsent extends Component {
    state = {
        checked_tos: false,
        checked_dp: false,
    }

    handleCheckboxTOS = () => {
        this.setState({ checked_tos: !this.state.checked_tos });
    }

    handleCheckboxDP = () => {
        this.setState({ checked_dp: !this.state.checked_dp });
    }

    handleButton = () => {
        const st = new URLSearchParams(this.props.location.search).get("state");
        window.location.replace(`https://scifork-dev.eu.auth0.com/continue?state=${st}`)

    }

    render() {
        return (
            <div className="container-uc">
                <div className="content-uc">

                    <div className="logo-lp">
                        <img src="./logo.png" style={{ maxHeight: "40%" }} alt="Artblast logo" />
                    </div>

                    <div className="login-container">
                        <label className="checkboxes">
                            <input
                                type="checkbox"
                                checked={this.state.checked_dp}
                                onChange={this.handleCheckboxDP}
                            />
                            Check here to indicate that you have read and agree to the <Link to="/privacy-policy" className="link">Privacy Policy </Link>
                        </label>



                        <label className="checkboxes">
                            <input
                                type="checkbox"
                                checked={this.state.checked_tos}
                                onChange={this.handleCheckboxTOS}
                            />
                            Check here to indicate that you have read and agree to the
                            <Link to="/terms-of-service" className="link"> Terms of Service </Link>
                        </label>
                    </div>

                    <div className="login-container">
                        <button
                            className="button-login"
                            disabled={!(this.state.checked_tos && this.state.checked_tos)}
                            onClick={this.handleButton}>
                            Accept
                        </button>
                    </div>




                </div>

            </div>
        );

    }
}

export default UserConsent;